import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

const icon1 = "https://winpeforum.com/assets/elements/Anjali-Mahajan.png";
const icon2 = "https://winpeforum.com/assets/elements/manshachugani.jpg";
const icon3 = "https://winpeforum.com/assets/elements/VarunaKhattri.jpg";
const icon4 = "https://winpeforum.com/assets/elements/Kaushalya.avif";
 
 

let duration = 400;

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    this.Speaker2 = [
     
  
  
        {
          imgUrl: icon4,
          desc: `<div>
Kaushalya is a seasoned corporate lawyer. Her practice areas are mergers and acquisitions, private equity and venture capital. She represents both institutional funds, large MNCs as well as startups and has been consistently ranked in IFLR 1000 as a ‘Notable Practitioner’ consistently since 2022 and she has also been ranked in Legal 500.



 
          </div>`,
          name: "Kaushalya Venkataraman ",
          post: `<div>Partner<br/>
Chandhiok & Mahajan




          </div>`,
        },
  ];
    this.Speaker1 = [
        {
          imgUrl: icon1,
          desc: `<div>
Anjali is an Investment Professional at Lighthouse Funds, where she has spent three years in Consumer investing. Before this, she spent four years in Investment Banking at Axis Capital. There, she advised mid-market Indian corporations on their fund-raise endeavours across the focus sectors of Chemicals, Pharma and Lifesciences, Logistics and Manufacturing.

 
          </div>`,
          name: "Anjali Mahajan",
          post: `<div>Investment Professional<br/>
Lighthouse Funds



          </div>`,
        },
       
        {
          imgUrl: icon2,
          desc: `<div>
Mansha Chugani is a Vice President in the Investor Relations &amp; Business
Development team at Everstone, based in Singapore. She plays an active role
in fostering the firm’s investor relationships and advancing the firm’s
sustainability initiatives.<br/><br/>
Before joining Everstone, Mansha spent six years at Partners Group, a global
investment firm, working across Investor Relations and Product Management.<br/><br/>
She began her career at Infosys, a multinational IT company, where she built a
strong foundation in analytical and strategic skills.<br/><br/>
Mansha holds a Bachelor of Engineering degree in Computer Science.



          </div>`,
          name: "Mansha Chugani",
          post: `<div>Vice President (Investor Relations)<br/>
Everstone


          </div>`,
        },
        {
            imgUrl: icon3,
          desc: `<div>
  Varuna Khattri is an investment professional in the Real Assets group at CPP Investments, with around a decade of experience across the full investment lifecycle, including transaction execution, asset management, and value creation. She has worked on complex investments in sectors including transport and highways, ports and logistics, telecom, data centres, and energy transition sectors, contributing to investment decision-making and long-term capital deployment. Varuna holds an MBA from IIM Shillong and is a graduate of Hindu College, University of Delhi. 

          </div>`,
          name: "Varuna Khattri",
          post: `<div>Investment Professional<br/>
CPPIB


          </div>`,
          },
          
    ];
 
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="Winpe Ignite Career Talk Session"
          image={"https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png"}
          description="On 21st February 2026, we hosted another edition of Winpe’s Ignite Career Talk Series — this time in a masterclass format centered around the theme “If I Were Starting My PE/VC Career Today: Senior Investors Reflect on What They’d Do Differently in Today’s Market.”
"
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">Winpe Ignite Career Talk Series <br/>If I Were Starting My PE/VC Career Today </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                  <span>February 21, 2026</span>
                  <br/>
                  <span> <i>Online</i></span>
                </div>
              </div>
              <br/>
 
 
              <div className="top_text" style={{textAlign: 'justify'}}> 
       On 21st February 2026, we hosted another edition of Winpe’s Ignite Career Talk Series — this time in a masterclass format centered around the theme “If I Were Starting My PE/VC Career Today: Senior Investors Reflect on What They’d Do Differently in Today’s Market.”
<br/><br/>

The session brought together senior women investors who shared candid reflections on their early career decisions, pivotal mistakes, defining moments, and how the PE/VC landscape has evolved over the years. The conversation moved beyond technical skills and focused on judgment, conviction, risk assessment, networking, and long-term career building in an increasingly competitive and technology-driven market.<br/><br/>

The discussion offered practical guidance for aspiring professionals — particularly those navigating early career stages or considering transitions into Private Equity and Venture Capital.
<br/><br/>

Catch the full recording <a href="https://www.youtube.com/watch?v=D6cYDRUFlIw" target="_blank" style={{color:'blue', textDecoration:'underline'}}>here</a><br/><br/>
Through sessions like these, Winpe continues its mission to empower women with the tools and perspective they need to enter and thrive in the ever-evolving culture of PEVC.



<br/> 
  


<h3><b>Key Highlights:</b></h3>
 
<ul>
   
    
<li><h4><b>Start with clarity, not complexity</b></h4> 
The speakers emphasized that many early-career professionals equate complexity with sophistication. However, the strongest investment theses are often simple, clearly articulated, and rooted in structured thinking. Being able to explain what a business does, how it creates value, and what risks exist — in simple terms — signals true depth of understanding.
</li> 

 

<li><h4><b>Build structured thinking and commercial judgment early</b></h4> Financial modelling is foundational, but it is only hygiene. What differentiates strong investors is commercial instinct — understanding management quality, regulatory dynamics, sector shifts, and behavioral signals that cannot always be captured in spreadsheets.
</li> 

<li><h4><b>Develop a personal point of view</b>
</h4>Tracking sectors, writing investment theses, debating ideas, and building independent conviction were highlighted as critical career accelerators. A differentiated perspective demonstrates readiness for larger responsibilities within investment teams.
</li> 

<li><h4><b>Networking compounds over time</b></h4> The speakers underscored the importance of proactive outreach — attending industry events, speaking to professionals, and maintaining long-term relationships. Networks often evolve into deal flow sources, mentors, advocates, and long-term career supporters.
</li> 

<li><h4><b>Focus on learning, not just brand names</b></h4> Early career decisions should prioritize exposure and learning opportunities over prestigious firm names. Depth of experience, curiosity, and initiative shape long-term trajectory more than logos on a resume.
</li>

<li><h4><b>Confidence is calm clarity, not dominance</b></h4> Effective investors are not necessarily the loudest voices in the room. Clear articulation of risks, structured communication in IC discussions, and thoughtful framing of downside scenarios build credibility over time.
</li>

<li><h4><b>AI will accelerate analysis — but not replace judgment</b></h4> The session also explored AI’s growing presence in investing. While AI can improve efficiency in document review, benchmarking, and sensitivity analysis, final underwriting decisions, accountability, and capital allocation remain fundamentally human responsibilities.
</li>


</ul>
<br/> 
<h3><b>Q&A Highlights:</b></h3>
 
 <p>Audience questions covered transitions from capital markets and consulting into PE funds, positioning CVs for investment roles, building conviction when pitching ideas internally, and navigating non-traditional career paths into investing.
</p>
<br/> 


<br/> 



              </div>
              <br />

              
           
<br/>  

<div class="row">
  
<div class="col-md-12"> 
              <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Speakers</h2>          <div class="r_btm"></div>
                      
                 
                      <div className="Our_Speakers container">
                        <center>
                          <div className="Speakers_img" style={{ width: '80%' }}>
                          <div className="row">

{this.Speaker1.map((item, i) => {
 if(i<=12) 
 {
  return (
    <div
      className="main_speaker_card col-md-4 col-sm-12 col-lg-4"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
 }
 else 
 return (
    <div
      className="main_speaker_card col-md-6 col-sm-12 col-lg-6"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
})}
</div>
                          </div>

                        </center>
                      </div>
                 </div>   
                 
        
</div>
<div class="row">
  
<div class="col-md-12"> 
              <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Moderator</h2>          <div class="r_btm"></div>
                      
                 
                      <div className="Our_Speakers container">
                        <center>
                          <div className="Speakers_img" style={{ width: '50%' }}>
                          <div className="row">

{this.Speaker2.map((item, i) => {
 if(i<=12) 
 {
  return (
    <div
      className="main_speaker_card col-md-12 col-sm-12 col-lg-12"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
 }
 else 
 return (
    <div
      className="main_speaker_card col-md-6 col-sm-12 col-lg-6"
      key={i}
    >
      <div className="Scardd">
        <div
          className="s_img"
          onClick={() => this.togglePopUp(item)}
        >
           <center>  <img
            src={item.imgUrl}
            alt={item.name}
            className="img-responsive"
            style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
          />
          </center>
        </div>
        <br />    <div
          className="Speakers_name"
          dangerouslySetInnerHTML={{ __html: item.name }}
        ></div>
        <div
          className="Speakers_post"
          dangerouslySetInnerHTML={{ __html: item.post }}
        ></div>
      </div>
    </div>
  );
})}
</div>
                          </div>

                        </center>
                      </div>
                 </div>   
                 
        
</div>
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/IgniteSession21Feb2026/index.js